module.exports = __webpack_public_path__ + "img/9788956243238.feb2dc61.jpg";